var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectParking2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1199,
    height: 861,
    viewBox: "0 0 1199 861",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 24,
    d: "M991.918 169.995V173.456V184.934V202.789H1067.33V184.934V169.995H991.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 23,
    d: "M991.918 132.309V137.31V150.099V169.995H1067.33V150.099V132.309H991.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 21,
    d: "M844.918 170.213V173.651V185.052V202.789H920.329V185.052V170.213H844.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 22,
    d: "M844.918 132.156V137.129V149.846V169.631H920.136V149.846V132.156H844.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 14,
    d: "M745.245 355.511L748.967 355.511L759.937 355.511L773.293 355.511L773.293 291.786L759.937 291.786L745.245 291.786L745.245 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 13,
    d: "M713.718 355.511L717.822 355.511L729.921 355.511L744.65 355.511L744.65 291.786L729.921 291.786L713.718 291.786L713.718 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 37,
    d: "M568.718 478.999L574.297 478.999L590.742 478.999L610.762 478.999L610.762 417.329L590.742 417.329L568.718 417.329L568.718 478.999Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 38,
    d: "M610.431 478.998L614.303 478.998L625.718 478.998L639.615 478.998L639.615 417.329L625.718 417.329L610.431 417.329L610.431 478.998Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 39,
    d: "M640.223 490.912L644.908 490.912L658.718 490.912L675.53 490.912L675.53 417.329L658.718 417.329L640.223 417.329L640.223 490.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 40,
    d: "M675.53 490.912L680.23 490.912L694.084 490.912L710.949 490.912L710.949 417.329L694.084 417.329L675.53 417.329L675.53 490.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: 41,
    d: "M711.223 490.912L715.422 490.912L727.8 490.912L742.868 490.912L742.868 417.329L727.8 417.329L711.223 417.329L711.223 490.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: 42,
    d: "M742.868 490.912L747.081 490.912L759.498 490.912L774.614 490.912L774.614 417.329L759.498 417.329L742.868 417.329L742.868 490.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: 51,
    d: "M712.706 568.864L720.099 568.864L740.833 568.864L768.42 568.864L768.42 491.692L740.833 491.692L712.706 491.692L712.706 568.864Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: 11,
    d: "M640.718 355.511L645.399 355.511L659.197 355.511L675.994 355.511L675.994 291.786L659.197 291.786L640.718 291.786L640.718 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M675.994 355.511L680.889 355.511L695.317 355.511L712.882 355.511L712.882 291.786L695.317 291.786L675.994 291.786L675.994 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: 35,
    d: "M495.223 490.912L500.102 490.912L514.485 490.912L531.994 490.912L531.994 417.329L514.485 417.329L495.223 417.329L495.223 490.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: 36,
    d: "M531.994 490.912L536.889 490.912L551.317 490.912L568.882 490.912L568.882 417.329L551.317 417.329L531.994 417.329L531.994 490.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: 61,
    d: "M205.718 564.974L210.399 564.974L224.197 564.974L240.994 564.974L240.994 493.47L224.197 493.47L205.718 493.47L205.718 564.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: 60,
    d: "M240.994 564.974L245.889 564.974L260.317 564.974L277.882 564.974L277.882 493.47L260.317 493.47L240.994 493.47L240.994 564.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: 59,
    d: "M349.768 564.974L354.681 564.974L369.163 564.974L386.793 564.974L386.793 493.47L369.163 493.47L349.768 493.47L349.768 564.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: 58,
    d: "M386.92 564.974L391.566 564.974L405.26 564.974L421.932 564.974L421.932 493.47L405.26 493.47L386.92 493.47L386.92 564.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M492.718 355.511L497.399 355.511L511.197 355.511L527.994 355.511L527.994 291.786L511.197 291.786L492.718 291.786L492.718 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M527.994 355.511L532.889 355.511L547.317 355.511L564.882 355.511L564.882 291.786L547.317 291.786L527.994 291.786L527.994 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M419.884 355.511L424.565 355.511L438.363 355.511L455.16 355.511L455.16 291.786L438.363 291.786L419.884 291.786L419.884 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M455.16 355.511L460.055 355.511L474.483 355.511L492.048 355.511L492.048 291.786L474.483 291.786L455.16 291.786L455.16 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M347.814 355.511L352.495 355.511L366.293 355.511L383.091 355.511L383.091 291.786L366.293 291.786L347.814 291.786L347.814 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M383.091 355.511L387.986 355.511L402.414 355.511L419.978 355.511L419.978 291.786L402.414 291.786L383.091 291.786L383.091 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M275.718 355.511L280.399 355.511L294.197 355.511L310.994 355.511L310.994 291.786L294.197 291.786L275.718 291.786L275.718 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M310.994 355.511L315.889 355.511L330.317 355.511L347.882 355.511L347.882 291.786L330.317 291.786L310.994 291.786L310.994 355.511Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: 91,
    d: "M532.814 692.78L537.045 692.78L548.248 692.78L564.697 692.78L564.697 633.28L548.248 633.28L532.814 633.28L532.814 692.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: 89,
    d: "M494.647 692.955L499.693 692.955L513.052 692.955L532.67 692.955L532.67 633.28L513.052 633.28L494.647 633.28L494.647 692.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: 77,
    d: "M278.768 692.694L283.48 692.694L297.371 692.694L314.282 692.694L314.282 633.47L297.371 633.47L278.768 633.47L278.768 692.694Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: 79,
    d: "M314.607 692.694L318.609 692.694L330.404 692.694L344.763 692.694L344.763 633.47L330.404 633.47L314.607 633.47L314.607 692.694Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: 33,
    d: "M422.604 491.426L427.301 491.426L441.143 491.426L457.994 491.426L457.994 417.322L441.143 417.322L422.604 417.322L422.604 491.426Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: 34,
    d: "M457.994 490.914L462.889 490.914L477.317 490.914L494.882 490.914L494.882 417.322L477.317 417.322L457.994 417.322L457.994 490.914Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: 63,
    d: "M133.718 564.974L138.399 564.974L152.197 564.974L168.994 564.974L168.994 493.47L152.197 493.47L133.718 493.47L133.718 564.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: 64,
    d: "M86 565L92.3694 565L111.144 565L134 565L134 493.478L111.144 493.478L86 493L86 565Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: 65,
    d: "M74.04 693.378L77.8484 693.378L89.074 693.378L102.74 693.378L102.74 633.618L89.074 633.618L74.04 633.618L74.04 693.378Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: 66,
    d: "M74.04 753.101L77.8484 753.101L89.074 753.101L102.74 753.101L102.74 694.419L89.074 694.419L74.04 694.419L74.04 753.101Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: 62,
    d: "M168.994 564.974L173.889 564.974L188.317 564.974L205.882 564.974L205.882 493.47L188.317 493.47L168.994 493.47L168.994 564.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: 67,
    d: "M102.74 693.378L107.635 693.378L122.063 693.378L139.628 693.378L139.628 633.618L122.063 633.618L102.74 633.618L102.74 693.378Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: 68,
    d: "M102.74 753.101L107.635 753.101L122.063 753.101L139.628 753.101L139.628 694.419L122.063 694.419L102.74 694.419L102.74 753.101Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: 78,
    d: "M278.768 752.694L283.48 752.694L297.371 752.694L314.282 752.694L314.282 693.47L297.371 693.47L278.768 693.47L278.768 752.694Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: 80,
    d: "M314.607 752.694L318.609 752.694L330.404 752.694L344.763 752.694L344.763 693.47L330.404 693.47L314.607 693.47L314.607 752.694Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: 92,
    d: "M532.557 752.487L536.759 752.487L547.885 752.487L564.224 752.487L564.224 693.28L547.885 693.28L532.557 693.28L532.557 752.487Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: 90,
    d: "M494.647 752.661L499.659 752.661L512.928 752.661L532.412 752.661L532.412 693.28L512.928 693.28L494.647 693.28L494.647 752.661Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: 109,
    d: "M883.841 696.095L889.059 696.095L902.876 696.095L923.166 696.095L923.166 633.464L902.876 633.464L883.841 633.464L883.841 696.095Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: 107,
    d: "M846.454 696.095L851.415 696.095L864.551 696.095L883.841 696.095L883.841 633.28L864.551 633.28L846.454 633.28L846.454 696.095Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: 26,
    d: "M991.918 315.543V319.369V332.054V351.789H1067.15V332.054V315.543H991.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: 25,
    d: "M991.918 283.352V287.612V298.505V315.451H1067.14V298.505V283.352H991.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: 114,
    d: "M956.894 753.106L961.972 753.106L975.419 753.106L995.166 753.106L995.166 695.031L975.419 695.031L956.894 695.031L956.894 753.106Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: 112,
    d: "M923.007 753.276L927.503 753.276L939.41 753.276L956.894 753.276L956.894 695.031L939.41 695.031L923.007 695.031L923.007 753.276Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: 113,
    d: "M956.841 696.095L962.059 696.095L975.876 696.095L996.166 696.095L996.166 633.766L975.876 633.766L956.841 633.766L956.841 696.095Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: 111,
    d: "M923.239 696.095L927.698 696.095L939.504 696.095L956.841 696.095L956.841 633.766L939.504 633.766L923.239 633.766L923.239 696.095Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: 88,
    d: "M460.226 752.682L464.581 752.682L475.718 752.682L493.045 752.682L493.045 692.058L475.718 692.058L460.226 692.058L460.226 752.682Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: 86,
    d: "M419.292 752.726L424.734 752.726L438.651 752.726L460.302 752.726L460.302 692.06L438.651 692.06L419.292 692.06L419.292 752.726Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: 87,
    d: "M460.204 691.821L464.559 691.821L475.697 691.821L493.024 691.821L493.024 633.393L475.697 633.393L460.204 633.393L460.204 691.821Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: 85,
    d: "M419.271 691.925L424.712 691.925L438.63 691.925L460.281 691.925L460.281 633.395L438.63 633.395L419.271 633.395L419.271 691.925Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: 84,
    d: "M386.619 752.719L390.974 752.719L402.112 752.719L419.439 752.719L419.439 691.937L402.112 691.937L386.619 691.937L386.619 752.719Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: 82,
    d: "M346.77 752.705L352.068 752.705L365.617 752.705L386.696 752.705L386.696 691.938L365.617 691.938L346.77 691.938L346.77 752.705Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: 83,
    d: "M386.919 691.821L391.179 691.821L402.074 691.821L419.024 691.821L419.024 633.166L402.074 633.166L386.919 633.166L386.919 691.821Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: 81,
    d: "M346.877 691.925L352.2 691.925L365.815 691.925L386.994 691.925L386.994 633.395L365.815 633.395L346.877 633.395L346.877 691.925Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: 72,
    d: "M167.943 752.966L173.864 752.966L189.004 752.966L212.559 752.966L212.559 694.615L189.004 694.615L167.943 694.615L167.943 752.966Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: 70,
    d: "M141.669 753.07L145.178 753.07L154.154 753.07L168.117 753.07L168.117 694.395L154.154 694.395L141.669 694.395L141.669 753.07Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: 19,
    d: "M844.918 242.361V246.721V257.871V275.217H920.329V257.871V242.361H844.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: 20,
    d: "M844.918 203.404V208.551V221.716V242.197H920.136V221.716V203.404H844.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M610.574 355.509L614.307 355.509L626.603 355.509L638.702 355.509L638.702 292.001L626.603 292.001L610.574 292.001L610.574 355.509Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M566.881 355.509L572.679 355.509L591.78 355.509L610.574 355.509L610.574 292.001L591.78 292.001L566.881 292.001L566.881 355.509Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: 46,
    d: "M885.157 493.016L890.139 493.016L902.879 493.016L922.698 493.016L922.698 417.009L902.879 417.009L885.157 417.009L885.157 493.016Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: 45,
    d: "M843.591 493.016L849.119 493.016L863.258 493.016L885.253 493.016L885.253 417.204L863.258 417.204L843.591 417.204L843.591 493.016Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: 48,
    d: "M844.195 532.307V537.205V549.732V569.22H922.329V549.732V532.307H844.195Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: 47,
    d: "M844.195 493.404V498.572V511.788V532.349H922.129V511.788V493.404H844.195Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: 56,
    d: "M460.615 564.74L465.161 564.74L476.788 564.74L494.874 564.74L494.874 493.166L476.788 493.166L460.615 493.166L460.615 564.74Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: 57,
    d: "M423.877 564.867L428.735 564.867L441.16 564.867L460.489 564.867L460.489 493.445L441.16 493.445L423.877 493.445L423.877 564.867Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: 54,
    d: "M531.615 564.74L536.161 564.74L547.788 564.74L565.874 564.74L565.874 493.166L547.788 493.166L531.615 493.166L531.615 564.74Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: 55,
    d: "M494.591 564.867L499.487 564.867L512.009 564.867L531.489 564.867L531.489 493.161L512.009 493.161L494.591 493.161L494.591 564.867Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: 52,
    d: "M676.615 568.717L681.161 568.717L692.788 568.717L710.874 568.717L710.874 492.898L692.788 492.898L676.615 492.898L676.615 568.717Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: 53,
    d: "M639.591 568.851L644.487 568.851L657.009 568.851L676.489 568.851L676.489 492.883L657.009 492.883L639.591 492.883L639.591 568.851Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: 44,
    d: "M806.886 492.653L811.766 492.653L824.247 492.653L843.663 492.653L843.663 417.009L824.247 417.009L806.886 417.009L806.886 492.653Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: 43,
    d: "M776.506 492.757L780.526 492.757L790.808 492.757L806.804 492.757L806.804 417.204L790.808 417.204L776.506 417.204L776.506 492.757Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: 16,
    d: "M807.165 355.544L817.19 355.544L842.829 355.544L842.829 291.758L807.165 291.758L807.165 355.544Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: 101,
    d: "M715.234 696.341L730.355 696.341L769.026 696.341L769.026 633.35L715.234 633.35L715.234 696.341Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: 102,
    d: "M715.234 753.409L730.355 753.409L769.026 753.409L769.026 696.478L715.234 696.478L715.234 753.409Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: 120,
    d: "M991.955 460.874V464.952V475.75V491.606H1067.33V475.75V460.874H991.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: 121,
    d: "M991.955 422.523V427.594V441.021V460.738H1067.33V441.021V422.523H991.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: 17,
    d: "M844.955 314.613V319.124V331.067V348.606H920.334V331.067V314.613H844.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: 18,
    d: "M844.955 277.119V282.066V295.165V314.399H920.334V295.165V277.119H844.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: 75,
    d: "M242.356 692.78L246.988 692.78L259.252 692.78L277.262 692.78L277.262 633.28L259.252 633.28L242.356 633.28L242.356 692.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: 73,
    d: "M212.804 692.955L216.74 692.955L227.161 692.955L242.464 692.955L242.464 633.28L227.161 633.28L212.804 633.28L212.804 692.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: 32,
    d: "M384.069 491.583L388.924 491.583L401.778 491.583L420.653 491.583L420.653 417.28L401.778 417.28L384.069 417.28L384.069 491.583Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: 31,
    d: "M349.378 491.801L353.957 491.801L366.083 491.801L383.888 491.801L383.888 417.28L366.083 417.28L349.378 417.28L349.378 491.801Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: 69,
    d: "M167.701 633.455L164.244 633.455L155.09 633.455L141.648 633.455L141.648 692.955L155.09 692.955L167.701 692.955L167.701 633.455Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: 71,
    d: "M212.944 633.28L206.976 633.28L191.175 633.28L167.971 633.28L167.971 692.955L191.175 692.955L212.944 692.955L212.944 633.28Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: 30,
    d: "M320.781 491.796L324.33 491.796L333.727 491.796L347.525 491.796L347.525 417.29L333.727 417.29L320.781 417.29L320.781 491.796Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: 29,
    d: "M277.48 491.669L283.226 491.669L298.44 491.669L320.781 491.669L320.781 417.29L298.44 417.29L277.48 417.29L277.48 491.669Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: 28,
    d: "M240.573 491.678L245.344 491.678L257.976 491.678L276.525 491.678L276.525 417.173L257.976 417.173L240.573 417.173L240.573 491.678Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: 27,
    d: "M206.48 491.678L210.981 491.678L222.897 491.678L240.395 491.678L240.395 417.173L222.897 417.173L206.48 417.173L206.48 491.678Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: 76,
    d: "M242.356 752.778L246.988 752.778L259.252 752.778L277.262 752.778L277.262 694.28L259.252 694.28L242.356 694.28L242.356 752.778Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: 74,
    d: "M214.647 752.949L218.339 752.949L228.112 752.949L242.464 752.949L242.464 694.28L228.112 694.28L214.647 694.28L214.647 752.949Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: 105,
    d: "M803.957 696.095L812.059 696.095L825.877 696.095L846.166 696.095L846.166 633.464L825.877 633.464L803.957 633.464L803.957 696.095Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: 103,
    d: "M770.647 696.095L775.45 696.095L788.167 696.095L804.137 696.095L804.137 633.28L788.167 633.28L770.647 633.28L770.647 696.095Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: 99,
    d: "M677.554 692.78L682.279 692.78L694.792 692.78L713.166 692.78L713.166 633.28L694.792 633.28L677.554 633.28L677.554 692.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: 97,
    d: "M637.647 692.955L642.923 692.955L656.891 692.955L677.402 692.955L677.402 633.28L656.891 633.28L637.647 633.28L637.647 692.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: 95,
    d: "M604.554 692.78L608.977 692.78L620.69 692.78L637.889 692.78L637.889 633.28L620.69 633.28L604.554 633.28L604.554 692.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: 93,
    d: "M564.647 692.955L569.923 692.955L583.891 692.955L604.402 692.955L604.402 633.28L583.891 633.28L564.647 633.28L564.647 692.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: 96,
    d: "M604.514 752.487L608.937 752.487L620.65 752.487L637.849 752.487L637.849 693.28L620.65 693.28L604.514 693.28L604.514 752.487Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: 94,
    d: "M564.607 752.661L569.883 752.661L583.851 752.661L604.362 752.661L604.362 693.28L583.851 693.28L564.607 693.28L564.607 752.661Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: 100,
    d: "M677.554 753.482L682.277 753.482L694.783 753.482L713.148 753.482L713.148 694.275L694.783 694.275L677.554 694.275L677.554 753.482Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: 98,
    d: "M637.647 753.656L642.923 753.656L656.891 753.656L677.402 753.656L677.402 694.275L656.891 694.275L637.647 694.275L637.647 753.656Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: 15,
    d: "M775.418 355.494L784.39 355.494L805.15 355.494L805.15 291.724L775.418 291.724L775.418 355.494Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: 116,
    d: "M1029.84 696.095L1034.83 696.095L1048.04 696.095L1067.44 696.095L1067.44 633.888L1048.04 633.888L1029.84 633.888L1029.84 696.095Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: 115,
    d: "M996.197 696.095L1000.66 696.095L1012.48 696.095L1029.84 696.095L1029.84 633.917L1012.48 633.917L996.197 633.917L996.197 696.095Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: 110,
    d: "M884.277 753.273L889.432 753.273L903.081 753.273L923.123 753.273L923.123 695.986L903.081 695.986L884.277 695.986L884.277 753.273Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: 108,
    d: "M846.647 753.257L851.567 753.257L864.591 753.257L883.718 753.257L883.718 695.986L864.591 695.986L846.647 695.986L846.647 753.257Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: 106,
    d: "M804.005 753.268L809.6 753.268L824.413 753.268L846.166 753.268L846.166 695.986L824.413 695.986L804.005 695.986L804.005 753.268Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: 104,
    d: "M770.647 753.436L775.09 753.436L786.855 753.436L804.13 753.436L804.13 696.325L786.855 696.325L770.647 696.325L770.647 753.436Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: 49,
    d: "M800.336 568.737L806.048 568.737L820.655 568.737L843.379 568.737L843.379 492.911L820.655 492.911L800.336 492.911L800.336 568.737Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: 50,
    d: "M769.95 568.871L773.995 568.871L784.338 568.871L800.429 568.871L800.429 492.986L784.338 492.986L769.95 492.986L769.95 568.871Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: 119,
    d: "M1115.27 569.222L1125.54 569.222L1151.8 569.222L1151.8 497.867L1115.27 497.867L1115.27 569.222Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: 117,
    d: "M1116.6 707.759L1126.62 707.759L1152.26 707.759L1152.26 641.611L1116.6 641.611L1116.6 707.759Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: 118,
    d: "M1116.6 770.91L1126.62 770.91L1152.26 770.91L1152.26 707.586L1116.6 707.586L1116.6 770.91Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectParking2);
export default __webpack_public_path__ + "static/media/select-parking-2.a165e39d.svg";
export { ForwardRef as ReactComponent };